import { breakPoints, breakPointsMax } from './bootstrap';

const body = UIkit.util.query('body');

/**
 * Social icon
 */
UIkit.util.on(window, 'load resize', e => {
    let targets;

    /**
     * ratio: 1.2
     */
    targets = [
        '.navbar-mobile .socials [uk-icon]',
        '.navbar-desktop .socials [uk-icon]',
        '.wrapp > footer .socials [uk-icon]',
    ];
    UIkit.icon(UIkit.util.queryAll(targets.join(',')), { 'ratio': 1.2 });

    targets = [
        '.navbar-mobile .socials [uk-svg]',
        '.navbar-desktop .socials [uk-svg]',
        '.wrapp > footer .socials [uk-svg]',
    ];
    UIkit.svg(UIkit.util.queryAll(targets.join(',')), { 'ratio': 1.2 });

    /**
     * ratio: 1.5
     */
    targets = [
        '.navlist .socials [uk-icon]',
    ];
    UIkit.icon(UIkit.util.queryAll(targets.join(',')), { 'ratio': 1.5 });

    targets = [
        '.navlist .socials [uk-svg]',
    ];
    UIkit.svg(UIkit.util.queryAll(targets.join(',')), { 'ratio': 1.5 });
});

/**
 * Header navigation animate.
 */
if (!UIkit.util.hasClass(body, 'contents')) {
    UIkit.util.on(window, 'load resize scroll', e => {

        /**
         * for Mobile
         */
        if (window.matchMedia(`(max-width: ${breakPointsMax.large}px)`).matches) {
            let navbar = UIkit.util.query('.navbar-mobile');
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

            UIkit.util.css(navbar, {
                'top': 0,
                'visibility': 'visible',
            });
            UIkit.util.removeClass(navbar, 'active');

            if (scrollTop > 80) {
                UIkit.util.css(navbar, {
                    'background-color': 'rgba(255, 250, 244, .95)',
                    'color': '#666',
                });
                UIkit.util.addClass(navbar, 'active');
            } else {
                UIkit.util.css(navbar, {
                    'background-color': 'transparent',
                    'color': '#fff',
                });
                UIkit.util.removeClass(navbar, 'active');

                if (scrollTop > 20) {
                    UIkit.util.css(navbar, 'top', '-80px');
                }
            }

            /**
             * for Desktop
             */
        } else if (window.matchMedia(`(min-width: ${breakPoints.large}px)`).matches) {
            let navbar = UIkit.util.query('.navbar-desktop');
            let height = navbar.clientHeight;
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

            UIkit.util.css(navbar, {
                'top': `${-height}px`,
                'visibility': 'visible',
            });

            if (scrollTop > 300) {
                UIkit.util.css(navbar, 'top', 0);
            } else {
                UIkit.util.css(navbar, 'top', `${-height}px`);
            }
        }
    });
}

/**
 *  Category search click event of archive page .
 */
if (UIkit.util.hasClass(body, 'archive')) {

    /**
     * 検索タイプのラジオボタンでフォームの action を変更する
     */
    UIkit.util.on('#archive-search', 'click', '[name="term_id"], [name="search_type"]', e => {
        // let form = UIkit.util.closest(e.target, 'form');
        let form = e.target.closest('form');
        form.action = UIkit.util.data(e.target, 'action');
    });

    /**
     * 表示件数が変更された時、選択された表示件数をセットして submit する
     */
    UIkit.util.on('.per-page', 'change', e => {
        let form = UIkit.util.query('#archive-search');
        let target = UIkit.util.query('[name="per_page"]', form);
        target.value = e.target.value;

        let submitButton = UIkit.util.query('[name="submit"]', form);
        submitButton.click();
    });
}
